import { render } from "./KontaktPage.vue?vue&type=template&id=4e3bf16c&scoped=true"
import script from "./KontaktPage.vue?vue&type=script&lang=js"
export * from "./KontaktPage.vue?vue&type=script&lang=js"

import "./KontaktPage.vue?vue&type=style&index=0&id=4e3bf16c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3bf16c"]])

export default __exports__